export default {
  MONTHLY: 0,
  SELDOM: 1,
  NEVER: 2
}
